import React, { useState, lazy, Suspense } from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import { pennylaneStatusColorClass } from '../Facturation/pennylaneLabels'

const PennylaneFactureModal = lazy(() => import('../Facturation/PennylaneFactureModal'));

// Pennylane transmission status of an invoicing-module document (billing/creditNote), shown at a
// glance in the invoice list: green = imported, orange = needs attention, blue = in progress,
// default = never sent yet
const PennylaneFactureBtn = ({factureId, factureBar, status, index, onChanged}) => {
    const t = useTranslate();
    const [show,setShow] = useState(false)

    const tooltip = status ? t('pennylaneStatus_'+status) : t('pennylaneStatusTitle')

    return (
        <>
            <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id={`tooltip-pennylane-facture-${index ?? factureId}`}>{tooltip}</Tooltip>}
            >
                <span onClick={() => setShow(true)} className={'pointer '+pennylaneStatusColorClass(status)}><FontAwesomeIcon icon={faCloudUploadAlt} /></span>
            </OverlayTrigger>
            {show &&
                <Suspense fallback={false}>
                    <PennylaneFactureModal factureId={factureId} factureBar={factureBar} show={show} onHide={() => setShow(false)} onChanged={onChanged} />
                </Suspense>
            }
        </>
    )
}

export default PennylaneFactureBtn;
